import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unify-marketing-details',
  templateUrl: './unify-marketing-details.component.html',
  styleUrls: ['./unify-marketing-details.component.css']
})
export class UnifyMarketingDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/prospect/unify-marketing-details/unify-marketing-details.component.ts